var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleTypeCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "13px",
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Travel,-Transport-+-Tracking-/-drive_",
    transform: "translate(-2.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "LUI-icon-pd-driving-outline-24",
    x: -7.46069873e-14,
    y: -5.00000006e-8,
    width: 24.0000001,
    height: 24.0000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50005676,10.0005254 L6.00005676,12.0005254 L18.0000568,12.0005254 L16.5000568,10.0005254 L7.50005676,10.0005254 Z M20.0000568,16.0005254 L18.0000568,16.0005254 L18.0000568,14.0005254 L6.00005676,14.0005254 L6.00005676,16.0005254 L4.00005676,16.0005254 L4.00005676,11.1605254 L4.71005676,10.1605254 L7.00005676,7.00052535 L17.0000568,7.00052535 L19.3300568,10.1805254 L20.0400568,11.1805254 L20.0000568,16.0005254 Z M22.0001135,7.00052535 L19.4500568,7.00052535 L18.5900568,5.82052535 C18.2040568,5.29252535 17.5840568,4.98552535 16.9300568,5.00052535 L7.07005676,5.00052535 C6.41605676,4.98552535 5.79605676,5.29252535 5.41005676,5.82052535 L4.55005676,7.00052535 L2,7.00052535 L2,9.00052535 L3.10005676,9.00052535 L2.33005676,10.0605254 C2.11305676,10.3485254 1.99705676,10.6995254 2,11.0605254 L2,16.0005254 C2,17.1045254 2.89605676,18.0005254 4.00005676,18.0005254 L7.00005676,18.0005254 C7.55205676,18.0005254 8.00005676,17.5535254 8.00005676,17.0005254 L8.00005676,16.0005254 L16.0000568,16.0005254 L16.0000568,17.0005254 C16.0000568,17.5535254 16.4470568,18.0005254 17.0000568,18.0005254 L20.0000568,18.0005254 C21.1040568,18.0005254 22.0001135,17.1045254 22.0001135,16.0005254 L22.0001135,11.0605254 C22.0030568,10.6995254 21.8870568,10.3485254 21.6700568,10.0605254 L20.9000568,9.00052535 L22.0001135,9.00052535 L22.0001135,7.00052535 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTypeCar);
export default __webpack_public_path__ + "static/media/vehicle-type-car.be0232604fb3692adda37309b1a64f94.svg";
export { ForwardRef as ReactComponent };